// TODO: This hook must be deleted once we have the solution to refresh the token from auth.js on server side,
// Most probably after migrating to Next 15 version

import { refreshAccessToken } from "@repo/server-actions/account";
import { useSession } from "next-auth/react";
import { useCallback, useEffect } from "react";

const TOKEN_REFRESH_INTERVAL_MS = 60 * 1000 * 45; // 45 minutes
const REFRESH_BUFFER_MS = 30000;

const useSessionRefresh = () => {
  const { data: session, status, update } = useSession();

  const refreshSessionToken = useCallback(async () => {
    if (session) {
      console.log("Attempting to refresh session token...");
      const refreshResponse = await refreshAccessToken(session);
      if (refreshResponse?.accessToken) {
        await update({
          ...session,
          user: {
            ...session.user,
            accessToken: refreshResponse.accessToken,
            tokenExpiryTime: refreshResponse.tokenExpiryTime,
            refreshToken: refreshResponse.refreshToken,
            refreshTokenExpiryTime: refreshResponse.refreshTokenExpiryTime,
          },
        });
        console.log("Session token refreshed successfully.");
      } else {
        console.error("Token refresh failed. User may need to reauthenticate.");
      }
    }
  }, [session, update]);

  // Set up an interval to refresh the token periodically
  useEffect(() => {
    if (status === "authenticated" && session) {
      // Calculate the time until the refresh should occur
      const timeUntilRefresh = TOKEN_REFRESH_INTERVAL_MS - REFRESH_BUFFER_MS;

      // Ensure timeUntilRefresh is non-negative
      const refreshInterval = Math.max(timeUntilRefresh, 0);

      const interval = setInterval(refreshSessionToken, refreshInterval);
      return () => clearInterval(interval); // Clear interval on component unmount
    }
  }, [refreshSessionToken, status, session]);

  // Refresh the session token when the user returns to the app
  /* useEffect(() => {
    const handleVisibilityChange = () => {
      if (document.visibilityState === "visible") {
        refreshSessionToken();
      }
    };
    document.addEventListener("visibilitychange", handleVisibilityChange);
    return () =>
      document.removeEventListener("visibilitychange", handleVisibilityChange);
  }, [refreshSessionToken]); */
};

export default useSessionRefresh;
